import { sidebar } from "./tokens";

/**
 * Theme riêng cho SIDEBAR navy (tách khỏi dashboardTheme của vùng nội dung).
 *
 * Toàn bộ style menu đẩy vào token AntD Menu (theme="dark") — thay cho cách
 * inject <style> vào document.head động theo isDarkMode trước đây ở Body.jsx.
 * Màu lấy từ bộ token `sidebar` (tham khảo CRM Conek).
 */
export const sidebarTheme = {
  components: {
    Menu: {
      darkItemBg: sidebar.bg,
      darkSubMenuItemBg: sidebar.bgSub,
      darkPopupBg: sidebar.bg,
      darkItemColor: sidebar.text,
      darkItemHoverBg: sidebar.hover,
      darkItemHoverColor: "#FFFFFF",
      darkItemSelectedBg: sidebar.active,
      darkItemSelectedColor: "#FFFFFF",
      itemBorderRadius: 8,
      itemMarginInline: 8,
      itemMarginBlock: 2,
      itemHeight: 40,
      iconSize: 16,
    },
  },
};
